import { css } from 'styled-components'

const bottomLine = css`
  border-bottom: ${props => props.theme.color.textTertiary} 1px solid;
`

export default bottomLine
